<template>
	<div class="h100 defaultRole-treeTable-main">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>{{ type === 'tenant' ? '租户角色预设列表' : '主体列表' }}</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="primary"
							   icon="el-icon-circle-plus"
							   size="small"
							   @click="add">新增</el-button>
				</div>
			</div>

			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="menusContent">
						<el-table :data="data"
								  border
								  highlight-current-row
								  @row-click="rowClick">
							<el-table-column prop="sname"
											 label="名称"
											 align="center"
											 show-overflow-tooltip></el-table-column>
							<el-table-column label="启用状态"
											 align="center"
											 v-if="type === 'tenant'">
								<template slot-scope="scope">
									<div class="state"
										 v-if="scope.row.is_flag">
										<el-button type="success"
												   circle
												   size="mini"></el-button>
										<span>启用</span>
									</div>
									<div class="state"
										 v-else>
										<el-button type="danger"
												   circle
												   size="mini"></el-button>
										<span>不启用</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="操作"
											 align="center"
											 width="150">
								<template slot-scope="scope">
									<el-button size="mini"
											   icon="el-icon-edit"
											   title="编辑"
											   type="text"
											   @click="edit(scope.row)"></el-button>
									<el-button size="mini"
											   icon="el-icon-delete"
											   title="删除"
											   type="text"
											   @click="deleteRow(scope.row)"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   center
				   :close-on-click-modal="false">
			<div>
				<el-form label-width="100px">
					<el-form-item label="名称">
						<el-input v-model="query.sname"></el-input>
					</el-form-item>
					<el-form-item label="启用状态">
						<el-switch v-model="query.is_flag"></el-switch>
					</el-form-item>
				</el-form>
			</div>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   @click="save">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.mainVisible"
				   :width="dialogObj.width"
				   center
				   :close-on-click-modal="false">
			<div>
				<el-form label-width="100px">
					<el-form-item label="名称">
						<el-input v-model="mainQuery.sname"></el-input>
					</el-form-item>
				</el-form>
				<el-form label-width="100px">
					<el-form-item label="备注">
						<el-input v-model="mainQuery.remark"
								  maxlength="150"
								  show-word-limit></el-input>
					</el-form-item>
				</el-form>
				<el-form label-width="100px">
					<el-form-item label="logo">
						<upload ref="upload"
								:aid="mainQuery.id"
							    :maxNum="1"
								:tableName="'sys_limit'"
								:assortment="mainQuery.id"></upload>
					</el-form-item>
				</el-form>
			</div>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.mainVisible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   @click="save">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	insertTenantPreinstall,
	deleteTenantPreinstall,
	saveOrUpdateLimit,
    deleteLimits
} from 'api/system/defaultRole'
import upload from '@/components/Upload/NewUpload'

export default {
	name: 'defaultRole-treeTable',
	components: { upload },
	props: {
		data: {
			type: Array,
			default: () => {
				return []
			}
		},

		type: {
			type: String,
			default: ''
		}
	},
	inject: ['selectTenantPreinstall', 'selectLimitall'],
	data() {
		return {
			dialogObj: {
				title: '',
				visible: false,
				mainVisible: false,
				width: '650px'
			},
			query: {
				id: '',
				sname: '',
				is_flag: false
			},
			mainQuery: {
				id: '',
				sname: '',
				parentId: '',
				limitType: '',
				remark: ''
			},
			uploadShow: false
		}
	},
	methods: {
		rowClick(obj) {
			this.$emit('row-click', obj.id, this.type)
		},

		// 新增
		add() {
			this.dialogObj.title = '新增'
			if (this.type === 'tenant') {
				this.query = {
					id: '',
					sname: '',
					is_flag: false
				}
				this.dialogObj.visible = true
			} else {
				this.mainQuery = {
					id: '',
					sname: '',
					parentId: '',
					limitType: ''
				}
				this.dialogObj.mainVisible = true
			}
		},

		// 编辑
		edit(row) {
			// console.log(row)
			this.dialogObj.title = '编辑'
			if (this.type === 'tenant') {
				this.query.sname = row.sname
				this.query.id = row.id
				this.query.is_flag = row.is_flag ? true : false

				this.dialogObj.visible = true
			} else {
				this.mainQuery.sname = row.sname
				this.mainQuery.id = row.id
				this.mainQuery.parentId = row.parentId
				this.dialogObj.mainVisible = true
				this.$nextTick(() => {
					this.$refs.upload.getFiles(row.id)
				})
			}
		},

		// 保存
		save() {
			if (this.type === 'tenant') {
				this.query.is_flag = this.query.is_flag ? true : false
				insertTenantPreinstall(this.query).then(res => {
					this.dialogObj.visible = false
					this.selectTenantPreinstall()
				})
			} else {
				saveOrUpdateLimit(this.mainQuery).then(res => {
					// console.log(res)
					this.$refs.upload.fileSend(res.data.id)
					this.dialogObj.mainVisible = false
					this.selectLimitall()
				})
			}
		},

		// 删除
		deleteRow(row) {
			this.$confirm('删除此项, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				if (this.type === 'tenant') {
					deleteTenantPreinstall({
						id: row.id
					}).then(res => {
						this.selectTenantPreinstall()
					})
				} else {
                    deleteLimits({
						id: row.id
					}).then(res => {
						this.selectLimitall()
					})
                }
			})
		}
	}
}
</script>

<style lang="less">
.defaultRole-treeTable-main {
	.state {
		height: 20px;
		line-height: 20px;
		width: 100%;
		position: relative;
		button {
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
		}
		span {
			margin-left: 20px;
		}
	}
}
</style>


